import React from 'react';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { PersistGate } from "redux-persist/integration/react";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { GoogleOAuthProvider, GoogleLogin, useGoogleLogin } from "@react-oauth/google";
const GOOGLE_CLIENT_ID = "764716966644-mra0j78knqbib9fpehcngjjt9lh4eell.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
	  <Provider store={store}>
		<PersistGate persistor={persistor}>
		  <App />
		</PersistGate>
	  </Provider>
	</GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
